import { schema } from "normalizr";

const preset = new schema.Entity(
    "presets",
    {},
    {
        idAttribute: "Id",
    }
);
export const presetsSchema = new schema.Array(preset);
export const presetSchema = preset;
